module.exports = __webpack_public_path__ + "static/media/automobile1.9a56c095.jpg";